import React, { useState, useRef, useEffect } from 'react';
import { X } from 'lucide-react';

const VideoShowcase = ({ videos }) => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [hoveredVideo, setHoveredVideo] = useState(null);
  const videoRefs = useRef({});

  useEffect(() => {
    // Autoplay all videos on mute when component mounts
    Object.values(videoRefs.current).forEach(video => {
      if (video) {
        video.play().catch(() => {
          // Silently handle autoplay errors
        });
      }
    });
  }, []);

  const openVideo = (video) => {
    setSelectedVideo(video);
  };

  const closeVideo = () => {
    setSelectedVideo(null);
  };

  const handleMouseEnter = (videoId) => {
    setHoveredVideo(videoId);
    const videoElement = videoRefs.current[videoId];
    if (videoElement) {
      videoElement.currentTime = 0;
      videoElement.play().catch(() => {});
    }
  };

  const handleMouseLeave = (videoId) => {
    setHoveredVideo(null);
  };

  return (
    <section className="video-showcase-section">
      <div className="container">
        <h2 className="showcase-title">Cinematic Stories We've Created</h2>
        
        <div className="video-grid">
          {videos.map((video, index) => (
            <div 
              key={video.id} 
              className="video-card"
              onClick={() => openVideo(video)}
              onMouseEnter={() => handleMouseEnter(video.id)}
              onMouseLeave={() => handleMouseLeave(video.id)}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="video-thumbnail-container">
                <video
                  ref={(el) => (videoRefs.current[video.id] = el)}
                  src={video.videoUrl}
                  className="video-preview"
                  muted
                  loop
                  playsInline
                  preload="auto"
                  poster={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 405 720'%3E%3Crect width='405' height='720' fill='%232a2a2a'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23d4af37' font-family='Arial' font-size='24' font-weight='bold'%3E${video.title}%3C/text%3E%3C/svg%3E`}
                  onError={(e) => {
                    console.log(`Video failed to load: ${video.title}`);
                    e.target.style.background = '#2a2a2a';
                  }}
                />
                <div className="video-overlay">
                  <span className="video-title-overlay">{video.title}</span>
                </div>
              </div>
              <p className="video-caption">{video.caption}</p>
            </div>
          ))}
        </div>
      </div>

      {selectedVideo && (
        <div className="video-modal" onClick={closeVideo}>
          <button className="close-button" onClick={closeVideo}>
            <X size={24} />
          </button>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="video-wrapper">
              <video
                src={selectedVideo.videoUrl}
                controls
                autoPlay
                className="modal-video"
              />
            </div>
            <p className="modal-caption">{selectedVideo.caption}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default VideoShowcase;
